const en = {
  common: {
    loading: 'Loading...',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    moveUp: 'Move up',
    moveDown: 'Move down',
    close: 'Close',
    confirm: 'Confirm',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    languageMenuTitle: 'Change language',
    pagerShow: 'Show',
    pagerPerPage: 'per page',
    pagerOf: 'of',
    viewCards: 'Card view',
    viewList: 'List view',
    collapse: 'Collapse',
    expand: 'Expand',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    retry: 'Retry',
    errorBoundaryTitle: 'Something went wrong',
    errorGeneric: 'An unexpected error occurred. Please try again.',
    expandModal: 'Expand in modal',
    resetToGlobal: 'Reset to global',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Home',
    growth: 'Growth',
    admin: 'Administration',
    executive: 'Executive',
    analytics: 'Analytics',
    switchDemoProfile: 'Switch demo profile',
    mobileNav: 'Main navigation',
  },
  roles: {
    employee: 'Employee',
    adminOU: 'OU Admin',
    adminGlobal: 'Global Admin',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Pending surveys',
    pending: 'Pending',
    completed: 'Completed',
    expired: 'Expired',
    submit: 'Submit evaluation',
    skip: 'Skip',
    noObs: 'No observation',
    meeting: 'Meeting',
    duration: 'Duration',
    participants: 'Participants',
    simulateMeeting: 'Simulate meeting end',
    thankYou: 'Thank you for your evaluation!',
    evaluating: 'Evaluating',
    of: 'of',
    question: 'Question',
    selectResponse: 'Select a response',
    nps: {
      question: 'How likely are you to recommend working with this person?',
      detractor: 'Detractor',
      passive: 'Passive',
      promoter: 'Promoter',
    },
    evaluateNow: 'Evaluate now',
    postpone: 'Later',
    expires: 'Expires',
    noSurveysPending: 'No pending surveys! Great job.',
    weekCompleted: 'wk.',
    likert: {
      always: 'Always',
      usually: 'Usually',
      sometimes: 'Sometimes',
      rarely: 'Rarely',
      notObservable: 'Not observable',
    },
    questions: {
      listenedActivelyText: 'Did this person listen actively and show genuine interest?',
      sharedKnowledgeText: 'Did they share relevant knowledge or experiences during the session?',
    },
    completeSubtitle: 'Your feedback helps strengthen the team culture.',
    backToHome: 'Back to home',
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    pendingCountPre: 'You have',
    pendingCountSingular: 'pending survey',
    pendingCountPlural: 'pending surveys',
    allDoneTitle: 'All caught up!',
    allDoneSubtitle: 'You have no pending surveys. They will appear here after your next meeting.',
    omit: 'Skip',
    omitSurvey: 'Skip survey',
    submitSuccess: 'Answers submitted',
    submitError: 'Error submitting — please try again',
    omitSuccess: 'Survey skipped',
    omitError: 'Error skipping — please try again',
    kpi: {
      answered: 'Answered',
      omitted: 'Skipped',
      streak: 'Streak',
      participation: 'Participation',
    },
    growth: {
      title: 'Your growth awaits',
      message: 'Review your results, trends, and development areas in your growth dashboard.',
      cta: 'See my growth',
    },
    tips: {
      title: 'Tips for you',
      based: 'Based on your average score',
      empty: 'Complete more surveys to see personalized tips',
      reconocer: 'To recognize',
      crecer: 'To grow',
      tipOfDay: 'Tip of the day',
    },
  },
  safe: {
    title: 'My Growth',
    subtitle: 'Your cultural development at Sigma',
    sectionName: 'My feedback',
    surveysAnswered: 'Surveys answered',
    score: 'Your Score',
    evolution: 'Your evolution',
    evolutionSub: 'Your personal journey — just you, no comparisons',
    radarTitle: 'Your profile by Fundamental',
    radarSub: 'You today vs you 3 months ago',
    fundamentals: 'Fundamentals',
    fundamentalsChart: 'Your feedback by Fundamental',
    fundamentalsChartSub: 'Where you stand on each — click any bar for detail',
    behaviors: 'Behaviors',
    kudos: 'Kudos',
    kudosTitle: 'To Recognize — what you bring most',
    kudosSub: 'What your peers observe most about you this month',
    actions: 'Action plan',
    omissions: 'Omissions',
    period: 'Period',
    received: 'Received',
    sent: 'Sent',
    areaAverage: 'Area average',
    today: 'Today (Jan 2026)',
    threeMonthsAgo: '3 months ago (Oct 2025)',
    detail: 'Detail',
    profileTitle: 'Your cultural profile in words',
    profileSub: 'Behaviors, not numbers',
    basedOn: 'Based on {{count}} anonymous feedbacks',
    level0: 'Beginning',
    level1: 'In Development',
    level2: 'Consistent',
    level3: 'Role Model',
    level0desc: 'Waits for others to solve problems or remove obstacles.',
    level1desc: 'Attempts to address obstacles but gives up quickly or escalates prematurely.',
    level2desc: 'Takes initiative to remove obstacles and find solutions to move things forward.',
    level3desc: 'Inspires others to take initiative and creates an environment where getting unstuck is a shared responsibility.',
    levelAbbr0: 'Start',
    levelAbbr1: 'In Dev.',
    levelAbbr2: 'Consiste.',
    levelAbbr3: 'Role Model',
    todayLabel: 'Today',
    pointsInMonths: 'points in {{n}} months',
    monthsWithFeedback: 'months with feedback',
    thisMonth: 'this month',
    headingToLevel: 'On the way to {{level}}',
    maxLevel: 'Maximum level!',
    narrativeStrength: 'What you contribute most and deserves recognition is <strong>{{fund}}</strong> — you are at level <strong>{{level}}</strong>.',
    narrativeConsistency: 'You also show consistency in {{others}}.',
    narrativeProgress: 'Over the last 3 months you have advanced — your profile shows growth.',
    narrativeStable: 'Your profile has remained stable over the last 3 months — that speaks of consistency.',
    narrativeVariation: 'Your profile has varied a little in recent months. Variations are normal and do not define who you are.',
    narrativeNextLevel: 'Your next level for growth is in <strong>{{fund}}</strong>. The next step is to reach level {{level}} — below we suggest a concrete action.',
    act01: 'Recognition — how others see you',
    act02: 'Progress — how you have evolved',
    act03: 'Direction — your next step',
    reinforces: 'REINFORCES',
    tryToday: 'I\'ll try this today',
    committed: 'I\'m committed today!',
    defaultChallenge: 'Practice a fundamental today',
    defaultChallengeDesc: 'Choose a micro-action and put it into practice in your next meeting.',
    clickDetail: 'Click for detail',
    nextLevel: 'NEXT LEVEL',
    growthTitle: 'TO KEEP GROWING',
    growthSub: 'Recommendations based on your feedback',
    feedbacks: 'feedbacks',
    peers: 'peers',
    givenTitle: 'My participation giving feedback',
    givenSub: 'Feedback you have shared this month',
    footerPrivacy: 'All feedback is anonymous. No one can see who gave it to you. This view is yours alone.',
    footerHeart: 'Remember: feedback is a gift. This data reflects moments in meetings, not who you are.',
    personSingular: 'person',
    personsPlural: 'people',
    trend: {
      up: 'Your profile shows growth',
      down: 'Small variation — that\'s normal',
      stable: 'Stable profile — that\'s consistency',
    },
    empty: {
      title: 'Get to know the Fundamentals',
      desc: "You don't have enough feedback yet to show your dashboard. In the meantime, explore the behaviors we measure.",
      hint: 'You need at least 3 evaluations to activate your personal dashboard. Take part in post-meeting surveys to start receiving feedback.',
    },
    popup: {
      peersOpined: 'peers rated',
      subbehaviors: 'Sub-behaviors',
      monthlyHistory: 'Monthly evolution',
      distribution: 'Feedback distribution',
      behaviorScale: 'Behavior scale',
      you: 'You',
    },
  },
  admin: {
    title: 'Administration',
    panelTitle: 'Admin Panel',
    roleAdminCentral: 'Central Admin',
    roleAdminOU: 'OU Admin',
    roleEmployee: 'Employee',
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    surveys: 'Surveys',
    templates: 'Templates',
    analyticsTab: 'Analytics',
    rulesTab: 'Business Rules',
    users: 'Users',
    notifications: 'Notifications',
    surveysTitle: 'Survey Management',
    searchSurvey: 'Search survey...',
    trash: 'Trash',
    newSurvey: 'New Survey',
    fundamentalsTab: 'General',
    customTab: 'Custom',
    colName: 'Name',
    colTitle: 'Title',
    colDescription: 'Description',
    colQuestions: 'Questions',
    colStatus: 'Status',
    colAudience: 'Audience',
    colFrequency: 'Frequency',
    colFeedback: 'Feedback',
    colPeriod: 'Period',
    colActions: 'Actions',
    colCreatedBy: 'Created by',
    colEmail: 'Email',
    colOU: 'OU',
    colUses: 'uses',
    statusActive: 'Active',
    statusPaused: 'Paused',
    statusInactive: 'Inactive',
    statusPending: 'Pending',
    anonymous: 'Anonymous',
    duplicate: 'Duplicate',
    exportExcelTip: 'Export Excel',
    templatesTitle: 'Survey Templates',
    tipsTab: 'Tips',
    actionsTab: 'Actions',
    catalogTab: 'Catalogs',
    createTemplate: 'Create template',
    typeFundamental: 'Fundamental',
    typeCustom: 'Custom',
    placeholderTips: 'Tips — Advice module for employees',
    placeholderActions: 'Actions — Post-survey action plans',
    placeholderCatalog: 'Fundamentals Catalog — Evaluable behavior library',
    tplSearchPlaceholder: 'Search template…',
    tplFilterAll: 'All types',
    tplNoResults: 'No templates match that criteria',
    tipsTitle: 'Feedback Tips',
    tipsSearchPlaceholder: 'Search tip…',
    tipsAllFundamentals: 'All Fundamentals',
    tipsAllTypes: 'All types',
    tipTypeReconocer: 'To Recognize',
    tipTypeCrecer: 'To Grow',
    tipsNoResults: 'No tips match that criteria',
    surveysNoResults: 'No surveys match that criteria',
    surveysError: 'Error loading surveys. Please try again later.',
    createTip: 'Create tip',
    actionsTitle: 'Growth Actions',
    actionsSearchPlaceholder: 'Search action…',
    actionsNoResults: 'No actions match that criteria',
    createAction: 'Create action',
    catalogTitle: 'Fundamentals Catalog',
    catalogFundamentals: 'Fundamentals',
    catalogBehaviors: 'Behaviors',
    catalogAddFundamental: 'Add Fundamental',
    catalogAddBehavior: 'Add Daily Habit',
    catalogSearchFundamental: 'Search fundamental…',
    catalogSearchBehavior: 'Search daily habit…',
    catalogNoBehaviors: 'No daily habits for this fundamental',
    catalogSelectFundamental: 'Select a Fundamental from the list',
    ousTab: 'OUs',
    ousTitle: 'Organisational Units',
    ousSubtitle: 'Manage root OUs for this tenant',
    ousSearchPlaceholder: 'Search OU…',
    ousNoResults: 'No OUs match that criteria',
    createOU: 'Create OU',
    editOU: 'Edit OU',
    deleteOU: 'Delete OU',
    deleteOUConfirm: 'Delete OU "{{name}}"? This action cannot be undone.',
    ouDescription: 'Description',
    ouAdminUser: 'OU Admin (AAD User ID)',
    ouType: 'Type',
    ouGdpr: 'GDPR',
    ouAzureGroupId: 'Azure AD Group ID',
    ouAzureGroupIdHint: 'Link this OU to its real Azure AD group for the hierarchical tree. Leave empty if not yet provisioned.',
    ouAzureGroupIdSelectPlaceholder: '— Select an Azure AD root group —',
    ouAzureGroupIdLoading: 'Loading Azure AD groups…',
    ouAzureGroupIdRootsError: 'Could not load the list of Azure AD groups. You can type the ID manually.',
    ouAzureGroupIdCurrentUnknown: 'Currently linked group (not in the list)',
    ouAzureGroupIdManualToggle: 'Type the ID manually',
    ouAzureGroupIdListToggle: 'Choose from the list',
    ouActivate: 'Activate OU',
    ouDeactivate: 'Deactivate OU',
    ouExpand: 'Expand',
    ouCollapse: 'Collapse',
    ouSelectPlaceholder: 'Select OU…',
    ouErrorName: 'OU name is required',
    ouTimezone: 'Timezone',
    ouTimezoneSelect: 'Select timezone',
    ouErrorTimezone: 'Timezone is required',
    colFundamental: 'Fundamental',
    colCondition: 'Condition',
    placeholderAnalytics: 'Unified Analytics Dashboard — See Executive view for full detail',
    activeUsersLabel: 'Active employees',
    avgCulturalScore: 'Average cultural score',
    participationRateLabel: 'Participation rate',
    omissionRateLabel: 'Omission rate',
    thisMonth: 'this month',
    rulesTitle: 'Business Rules',
    restoreDefaults: 'Restore Defaults',
    restoreDefaultsTitle: 'Restore default configuration',
    restoreDefaultsDesc: 'All business rule values will be reset to their original configuration. This action cannot be undone.',
    restoreDefaultsConfirm: 'Yes, restore',
    rn001Title: 'Meeting Criteria',
    rn001Subtitle: 'Defines the meeting duration that triggers a survey',
    rn002Title: 'Exclusion Rules',
    rn002Subtitle: 'Scenarios where surveys are NOT triggered',
    rn004Title: 'User Limits',
    rn004Subtitle: 'Controls the number of surveys each person receives',
    rn005Title: 'Daily Survey Limit',
    rn005Subtitle: 'Maximum number of surveys a user can receive per day',
    fieldMinSessionDuration: 'Minimum session duration',
    fieldMaxSessionDuration: 'Maximum session duration',
    fieldMinParticipants: 'Minimum participants',
    fieldMaxParticipants: 'Maximum participants',
    fieldExclRecurring: 'Exclude recurring meetings',
    fieldExclRecurringSub: 'Do not apply to weekly meetings, dailies, etc.',
    fieldExclWorkHours: 'Exclude outside working hours',
    fieldExclWorkHoursSub: 'Only apply within hours configured per OU',
    fieldMaxSurveysWeek: 'Maximum surveys per week',
    fieldMaxParticipantsPerSurvey: 'Maximum participants to evaluate per survey',
    fieldMinInterval: 'Minimum interval between surveys',
    fieldMaxSurveysDay: 'Maximum surveys per day per user',
    rn005Info: 'If a user has already received the maximum surveys for the day, the following ones are postponed to the next business day following the configured priority order.',
    suffixMinutes: 'minutes',
    suffixUsers: 'users',
    suffixSurveysWeek: 'surveys/week',
    suffixPersons: 'persons',
    suffixHours: 'hours',
    suffixSurveysDay: 'surveys / day',
    customizableByOU: 'Customizable per OU',
    cancelChanges: 'Cancel changes',
    saveConfig: 'Save configuration',
    rulesConfig: 'Configuration',
    rulesStatus: 'Status',
    rulesCustom: 'Custom',
    rulesSave: 'Save',
    rulesCancel: 'Cancel',
    rulesSchedule: 'Schedule',
    rulesInheritsGlobal: '↑ Inherits global',
    rulesInherited: 'Inherited',
    rulesGlobal: 'Global',
    rulesPersonalize: 'Customize',
    tplCatAll: 'All',
    tplCatGeneral: 'General',
    tplCatCustom: 'Custom',
    usersTitle: 'User Management',
    searchUser: 'Search user...',
    newUser: 'New user',
    notificationsTitle: 'Notification Settings',
    notifOmitirTitle: 'Skip Notification',
    notifyAfter: 'Notify after',
    consecutiveOmissions: 'consecutive skips',
    notifyTo: 'Notify:',
    notifyUser: 'User',
    notifyDirectManager: 'Direct manager',
    notifyAdminOU: 'OU Administrator',
    messageForUser: 'Message for the user:',
    availableVarsOmitir: 'Available variables: {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Europe Omissions (BU)',
    manualOnlyGDPR: 'Manual only — GDPR',
    gdprWarning: 'Due to legal regulations (GDPR), omission emails for Europe are never sent automatically. The administrator must draft, review and send them manually.',
    emailTemplateEmployee: 'Email template — Europe employee:',
    reviewBeforeSending: 'Review and customize before each send.',
    generalNotificationsTitle: 'General Notifications',
    notifMessageLabel: 'Notification message:',
    notifMessagePlaceholder: 'Write the message you want to send to employees...',
    notifAudienceLabel: 'Audience:',
    notifAudienceGlobal: 'Global (excl. Europe)',
    sendNotification: 'Send notification',
    availableVarsGeneral: 'Available variables: {nombre}, {ou}, {fecha}',
    saveChanges: 'Save changes',
    saveTemplates: 'Save templates',
    sidebarExpand: 'Expand menu',
    sidebarCollapse: 'Collapse menu',
    analyticsComingSoon: 'Analytics Dashboard — in development. See Executive view for full detail.',
    colType: 'Type',
    tplCategory: 'Category',
    tplQuestions: 'questions',
    tplUse: 'Use',
    tplDeleteTitle: 'Delete template',
    tplDeleteDesc: 'Delete "{{name}}"? This action cannot be undone.',
    tipDeleteTitle: 'Delete tip',
    tipDeleteDesc: 'Delete "{{name}}"? This action cannot be undone.',
    tipEditTitle: 'Edit tip',
    tipAddTitle: 'Add tip',
    tipFormFundamental: 'Fundamental',
    tipFormSelectFundamental: 'Select a fundamental…',
    tipFormDailyHabit: 'Linked Daily Habit',
    tipFormSelectDailyHabit: 'Select a Daily Habit…',
    tipFormOperator: 'Operator',
    tipFormThreshold: 'Threshold %',
    tipFormMax: 'Max %',
    tipFormType: 'Tip type',
    tipFormName: 'Tip name',
    tipFormNamePlaceholder: 'E.g. Outstanding Learning',
    tipFormText: 'Tip text',
    tipFormTextPlaceholder: 'Message the collaborator will see…',
    tipFormActivationRule: 'Result condition',
    tipFormActive: 'Active',
    tipFormPreview: 'Preview',
    tipRangeMin: 'Minimum limit',
    tipRangeMax: 'Maximum limit',
    tipHintCondition: 'Average score of the fundamental (0–100). E.g. 0 to 40 activates the tip on low results.',
    tipHintBehavior: 'Specific behavior this tip applies to.',
    tipFieldObserved: 'Observed text',
    tipTagGreen: 'light green box',
    tipTagDark: 'dark box',
    tipTagBlue: 'Next Level box',
    tipHintObserved: 'What peers observe most. Shown in italic in the achievements panel.',
    tipFieldGrowthSuggestion: 'Growth Suggestion',
    tipHintGrowthSuggestion: 'Actionable suggestion shown alongside the recognition.',
    tipFieldLevelName: 'Level name',
    tipLevelNamePlaceholder: 'E.g. Needed Impulse, Under Construction…',
    tipCrecerPairedPlaceholder: 'E.g. Mention the consumer: In your next decision, ask…',
    tipTranslations: 'Translations',
    tipAddLang: '+ Add:',
    tipPreviewContext: 'This is how it will appear on the collaborator dashboard:',
    tipSave: 'Save tip',
    tipSaveError: 'To save, complete the following fields:',
    colContent: 'Content',
    colActive: 'Active',
    opGte: 'greater or equal',
    opLte: 'less or equal',
    opGt: 'greater than',
    opLt: 'less than',
    opBetween: 'Between (range)',
    actionEditTitle: 'Edit action',
    actionNewTitle: 'New action',
    actionFormTitle: 'Action title',
    actionFormTitlePlaceholder: 'E.g. Propose a concrete action',
    actionFormDescription: 'Full description',
    actionFormDescPlaceholder: 'Action description…',
    actionActivationRule: 'Activation rule',
    actionActivationRuleHint: 'Fundamental average score (1–4). Defines the range that triggers this action.',
    actionRuleMin: 'Min threshold',
    actionRuleMax: 'Max threshold',
    actionRangeLabel: 'Range',
    actionNextLevelText: '"Next Level" text',
    actionNextLevelHint: 'Shown in the blue box on the card.',
    actionNextLevelPlaceholder: 'E.g. To reach the next level, focus on…',
    actionPreview: 'Preview',
    actionPreviewEmpty: 'Fill in the form to see the preview',
    actionTranslations: 'Translations',
    actionTransComplete: 'Translation complete',
    actionTransMissing: 'Translation incomplete',
    actionPreviewContext: 'This is how it will appear in the collaborator\'s dashboard:',
    actionFormDescHint: 'Shown when the action is opened.',
    actionSave: 'Save action',
    actionSaveError: 'To save, complete the following fields:',
    actionDeleteTitle: 'Delete action',
    actionDeleteDesc: 'Delete "{{name}}"? This cannot be undone.',
    fundEditTitle: 'Edit Fundamental',
    fundNewTitle: 'New Fundamental',
    fundFormFullName: 'Full name',
    fundFormFullNamePlaceholder: 'E.g. Mindset & Behavior - Learner',
    fundFormShortName: 'Short name',
    fundFormShortNamePlaceholder: 'E.g. Learner',
    fundFormDescription: 'Description',
    fundFormDescriptionPlaceholder: 'Brief description of this fundamental...',
    fundFormIcon: 'Icon',
    fundFormColor: 'Color',
    fundFormUrl: 'Reference URL',
    fundFormUrlPlaceholder: 'https://...',
    imageUploadSelect: 'Upload image',
    imageUploadChange: 'Change image',
    imageUploadInvalidFormat: 'Unsupported format. Use PNG, JPG, WEBP or SVG.',
    imageUploadTooLarge: 'File exceeds the maximum allowed size (2 MB).',
    fundFormLanguage: 'Language',
    fundFormAllLangsRequired: 'Fill in the full name, short name and description in all 7 languages to save.',
    behEditTitle: 'Edit Daily Habit',
    behNewTitle: 'New Daily Habit',
    behFormName: 'Daily Habit name',
    behFormNamePlaceholder: 'E.g. Humility & Openness',
    behFormAllLangsRequired: 'Fill in the name in all 7 languages to save.',
    behFormFundamental: 'Linked Fundamental',
    behFormIntro: 'Intro / evaluation context',
    behFormIntroPlaceholder: 'E.g. In this meeting, this person…',
    behFormRoles: 'Applicable roles',
    behFormRolesHint: 'Who does this Daily Habit apply to?',
    fundDeleteTitle: 'Delete fundamental',
    fundDeleteDesc: 'Delete "{{name}}"? This cannot be undone.',
    behDeleteTitle: 'Delete Daily Habit',
    behDeleteDesc: 'Delete "{{name}}"? This cannot be undone.',
    fundFormImage: 'Image',
    attNewTitle: 'New Attitude and Behavior',
    attEditTitle: 'Edit Attitude and Behavior',
    attFormName: 'Attitude and Behavior name',
    attFormNamePlaceholder: 'E.g. Active collaboration',
    attFormDescription: 'Attitude and Behavior description',
    attFormDescriptionPlaceholder: 'Brief description of this attitude and behavior...',
    attFormAllLangsRequired: 'Fill in the name in all 7 languages to save.',
    attFormImage: 'Image',
    attDeleteTitle: 'Delete Attitude and Behavior',
    attDeleteDesc: 'Delete "{{name}}"? Its Daily Habits will be deactivated too.',
    catalogAttitudesLabel: 'attitudes and behaviors',
    catalogSelectAttitude: 'Select an Attitude and Behavior from the list',
    catalogBackToFundamentals: 'Back to Fundamentals',
    catalogBackToAttitudes: 'Back to Attitudes and Behaviors',
    catalogGroupWithAttitudes: 'Group under Attitudes and Behaviors',
    catalogNoFundamentals: 'No fundamentals',
    madurezEditTitle: 'Edit Cultural Maturity levels',
    madurezFrameworkTitle: 'Cultural Maturity — Level framework',
    nivelesAdopcionTitle: 'Daily Habit Adoption Stages — Level framework',
    nivelesAdopcionEditTitle: 'Edit Daily Habit adoption stages',
    madurezLabelPlaceholder: 'Label',
    audienceGlobal: 'Global (excl. Europe)',
    audienceMexico: 'Mexico',
    audienceLATAM: 'LATAM',
    audienceUSA: 'USA',
    audienceFOSE: 'FOSE',
    rn000Title: 'Disable App per OU',
    rn000Subtitle: 'Completely turn off Sigma Pulse for one or more organizational units. Employees in those OUs will not receive surveys or notifications.',
    rn000Warning: 'When an OU is disabled, all its employees immediately stop receiving surveys. Historical data is preserved.',
    rn003Title: 'Working Hours per OU',
    rn003Subtitle: 'Hours during which surveys are applied (local time)',
    rn003GlobalDefault: 'Global default hours',
    rn003GlobalNote: 'Applies to all OUs that do not have custom hours configured.',
    rn003TimeConnector: 'to',
    ouActive: 'Active',
    ouDisabled: 'Disabled',
    rn002KwLabel: 'Exclude only if the name contains:',
    rn002KwHint: '(empty = all recurring)',
    rn002KwPlaceholder: 'Add keyword...',
    usersAdminTitle: 'Administrator Management',
    addAdmin: 'Add Administrator',
    editAdmin: 'Edit Administrator',
    newAdmin: 'New Administrator',
    adminEmail: 'Email address',
    adminEmailInvalid: 'Enter a valid email address (e.g. name@domain.com)',
    adminRole: 'Role',
    adminRolePlaceholder: 'Select a role...',
    adminOU: 'Operational Unit (OU)',
    adminOUPlaceholder: 'Select an OU...',
    adminOUAll: 'All (full OU access)',
    adminBU: 'Business Unit (BU) — optional',
    adminBUPlaceholder: 'Entire OU (no restriction)',
    adminBUHint: 'If no BU is selected, the admin manages the entire OU.',
    colUser: 'User',
    colAlcance: 'Scope',
    colPermisos: 'Permissions',
    colEstado: 'Status',
    permGlobalTitle: 'OU/BU Admins can create surveys',
    permGlobalDesc: 'When active, all OU/BU Admins can create and send surveys (subject to Central Admin approval).',
    permEnabled: 'Enabled',
    permDisabled: 'Disabled',
    permCreateSurveys: 'Create surveys',
    permViewAnalytics: 'View Analytics',
    permManageUsers: 'Manage Users',
    permApproveSurveys: 'Approve surveys',
    userDeleteTitle: 'Delete administrator',
    userDeleteDesc: 'Delete "{{name}}"? This action cannot be undone.',
    noUsersFound: 'No results found',
    adminCount: 'administrators',
    messageForManager: 'Message for the manager:',
    emailTemplateManager: 'Email template — Europa manager:',
    notifOUPersonalization: 'OU Personalization',
    addOUPersonalization: 'Add personalization',
    europaNoAutoSend: 'These emails are not sent automatically. They must be sent manually and aligned with the Europa privacy officer.',
    europaActivateTitle: 'Activate Europa notifications?',
    europaActivateDesc: 'Omission notifications for Europa are subject to strict GDPR regulations. By activating this section you confirm you have authorization from the Europa OU privacy officer and that emails will be sent manually with prior review.',
    europaActivateConfirm: 'Yes, activate responsibly',
    includeEuropa: 'Include Europa (BU)',
    includeEuropaHint: 'requires GDPR review before sending',
    europaSectionDisabled: 'Section disabled — enable the switch to configure',
    ouPersonalizedSingular: 'personalized OU',
    ouPersonalizedPlural: 'personalized OUs',
    notifCustomUserMsgPlaceholder: 'Custom message for the user…',
    notifCustomMgrMsgPlaceholder: 'Custom message for the manager…',
    kwRemove: 'Remove',
    kwAdd: 'Add',
    permissions: 'Permissions',
    rules: 'Business rules',
    catalog: 'Catalog',
    createUser: 'Create user',
    editUser: 'Edit user',
    deleteUser: 'Delete user',
    roles: 'Role',
    organizationalUnit: 'Organizational Unit',
    minDuration: 'Min duration (min)',
    maxDuration: 'Max duration (min)',
    minParticipants: 'Min participants',
    maxPerDay: 'Max evaluations per day',
    maxPerWeek: 'Max evaluations per week',
    omissionThreshold: 'Omission threshold',
    columns: 'Columns',
    colPickerTitle: 'Visible columns',
    colPickerReset: 'Reset',
    pagerRowsPerPage: 'Rows per page',
    pagerOf: 'of',
    confirmMoveToTrash: 'Move to trash?',
    confirmMoveToTrashMsg: 'The survey will be moved to the trash and permanently deleted after 30 days. You can restore it before that deadline.',
    confirmMoveBtn: 'Move to trash',
    confirmDeleteForeverTitle: 'Delete permanently?',
    confirmDeleteForeverMsg: 'This action is irreversible. The survey and all its data will be deleted forever.',
    confirmDeleteForeverBtn: 'Delete forever',
    trashTitle: 'Survey trash',
    trashSubtitle: 'Surveys are permanently deleted after 30 days',
    trashEmpty: 'The trash is empty',
    trashRestore: 'Restore',
    trashDaysLeft: 'days left',
    colSurvey: 'Survey',
    trashResponses: 'resp.',
    trashTimeLeft: 'Time remaining',
    trashDeletedBy: 'Deleted by',
    trashDeletedAt: 'Deletion date',
    trashDays: 'days',
    trashExpiresTODAY: 'Expires today',
    filterAll: 'All',
    filterSearchName: 'Search name…',
    filterSearchCreator: 'Search creator…',
    filterFrom: 'From',
    filterTo: 'To',
    filterClearDates: 'Clear dates',
    pauseSurvey: 'Pause',
    activateSurvey: 'Activate',
    builderNewTitle: 'New Survey',
    builderEditTitle: 'Edit Survey',
    builderNewTemplateTitle: 'New Template',
    builderEditTemplateTitle: 'Edit Template',
    builderBackToSurveys: 'Back to surveys',
    builderSaveDraft: 'Save draft',
    builderPublish: 'Publish survey',
    builderStep1: 'Basic Info',
    builderStep2: 'Audience & Frequency',
    builderStep3: 'Questions',
    builderStep4: 'Review',
    builderPreview: 'Preview',
    builderName: 'Survey name',
    builderNamePlaceholder: 'E.g.: Post-Meeting Evaluation Q2',
    builderDescription: 'Description',
    builderDescriptionPlaceholder: 'Describe the purpose of this survey…',
    builderApproach: 'Approach',
    builderApproachIndividual: 'Individual',
    builderApproachCollective: 'Collective',
    builderAnonymous: 'Anonymous evaluation',
    builderAnonymousSub: 'Evaluatees will not know who evaluated them',
    dayMon: 'Monday', dayTue: 'Tuesday', dayWed: 'Wednesday', dayThu: 'Thursday',
    dayFri: 'Friday', daySat: 'Saturday', daySun: 'Sunday',
    dayMonShort: 'Mon', dayTueShort: 'Tue', dayWedShort: 'Wed', dayThuShort: 'Thu',
    dayFriShort: 'Fri', daySatShort: 'Sat', daySunShort: 'Sun',
    dayLetterMon: 'M', dayLetterTue: 'T', dayLetterWed: 'W', dayLetterThu: 'T',
    dayLetterFri: 'F', dayLetterSat: 'S', dayLetterSun: 'S',
    activeDaysAll: 'The survey will be active all week',
    activeDaysPrefix: 'The survey will be active on:',
    activeDaysNone: 'No days selected',
    workdays: 'Workdays',
    builderExitTitle: 'Exit the editor?',
    builderExitDesc: 'Unsaved changes will be lost if you leave now.',
    builderExitCancel: 'Keep editing',
    builderExitConfirm: 'Yes, exit',
    builderValidationTitle: 'Required fields',
    builderValidationDesc: 'Please complete the following fields before continuing:',
    builderValidationClose: 'Got it',
    builderValidationName: 'Internal Identifier',
    builderValidationSurveyType: 'Survey type',
    builderValidationStartDate: 'Start date',
    builderValidationEndDate: 'End date',
    builderValidationDateRange: 'End date cannot be earlier than start date',
    builderValidationActiveDays: 'At least one active day',
    builderValidationMeetingId: 'Enter the Meeting ID',
    builderValidationPeople: 'Select at least one person',
    builderValidationOU: 'Select at least one OU',
    builderValidationNoQuestions: 'You must add at least one question to continue. Surveys cannot be created without questions.',
    builderValidationMinParticipants: 'Minimum participants must be at least 1',
    builderValidationMaxParticipants: 'Maximum participants must be at least 1',
    builderValidationParticipantsRange: 'Minimum participants cannot be greater than maximum',
    builderValidationTranslations: 'Incomplete translations',
    // Builder new keys
    builderCloseEditor: 'Close editor',
    builderPrevious: 'Previous',
    builderNext: 'Next',
    builderSaveTemplate: 'Save as template',
    builderInternalId: 'Internal identifier',
    builderInternalIdHint: 'Only visible to administrators — employees do not see this name when responding',
    builderSurveyTypeStar: 'Survey type',
    builderTypeGeneral: 'General',
    builderTypeGeneralDesc: 'Governed by business rules. Triggered automatically after meetings.',
    builderTypePersonalized: 'Personalized',
    builderTypePersonalizedDesc: 'Linked to a specific Teams session by Meeting ID.',
    builderPeriod: 'Survey period',
    builderStartLabel: 'Start',
    builderEndLabel: 'End',
    builderPeriodHint: 'The survey will activate on the start date and deactivate automatically when it ends',
    builderActiveDaysLabel: 'Active days',
    builderCustomTag: 'Custom',
    builderAudienceSectionTitle: 'Audience',
    builderWhoApplies: 'Who does this survey apply to?',
    builderSelectOneOrMoreOUs: 'Select one or more OUs',
    builderGlobal: 'Global',
    builderGlobalDesc: 'All OUs and BUs',
    builderExcludesEurope: 'excludes Europe',
    builderGlobalAdminOUAccess: 'Global Administrator — you have access to all OUs in the system.',
    builderLegalRegulation: 'Legal regulation — always a separate field',
    builderEurope: 'Europe (BU)',
    builderGDPRTag: 'GDPR — Legal regulation',
    builderEuropeExcludedNote: 'Europe is never included in Global or multi-OU campaigns due to legal compliance.',
    builderEuropaAuthNote: 'Remember to obtain authorization from the Europe OU before sending surveys to this region.',
    builderAudienceCustomTitle: 'Recipients',
    builderAudienceCustomSubtitle: 'Define who will receive this personalized survey.',
    builderRecipientsLabel: 'Recipients',
    builderByMeetingId: 'By Meeting ID',
    builderByPeople: 'Specific people',
    builderByOU: 'By org chart (OU)',
    audienceTypeMeeting: 'Meeting',
    audienceTypePeople: 'People',
    audienceTypeOU: 'OU',
    builderMeetingIdHint: 'Will apply to all participants of that Teams session',
    builderSelectPeople: 'Select people from the list',
    builderAllOUs: 'All OUs',
    builderAllAvailableAdded: 'All available people have already been added',
    builderSearchPeoplePlaceholder: 'Search for a person by name…',
    builderLoadingPeople: 'Loading people…',
    builderErrorLoadingPeople: 'Could not load the people list. Try again.',
    builderPersonSelected: 'person selected',
    builderPeopleSelected: 'people selected',
    builderSelectOU: 'Select an OU...',
    builderSelectOUForTeam: 'Select an OU to view its members',
    builderQuestionsTitle: 'Questions',
    builderEuropaQuestionsNote: 'Europe mode: open survey, not linked to Fundamentals. Questions about the meeting only.',
    builderQuestionsApplyToAll: 'Each question applies to every meeting participant.',
    builderFilterAll: 'All',
    builderNoQuestions: 'No questions yet',
    builderNoQuestionsHint: 'Click "+ Add question" to get started',
    builderNoQuestionsOfType: 'No questions of this type',
    builderAddQuestion: '+ Add question',
    builderQuestionLabel: 'Question',
    builderDeleteQuestion: 'Delete',
    builderApproachLabel: 'Approach',
    builderIndividualSub: 'Evaluates each participant',
    builderCollectiveSub: 'For the session as a whole',
    builderPresentationMode: 'Presentation mode',
    builderMatrix: 'General Matrix',
    builderMatrixSub: 'Question about the meeting or general topic',
    builderIndividualCard: 'Individual',
    builderIndividualCardSub: 'One card per person',
    builderTypeLabel: 'Type',
    builderFundamentalLabel: 'Fundamental',
    builderSelectFundamental: 'Select a Fundamental...',
    builderDailyHabitLabel: 'Daily Habit',
    builderSelectDailyHabit: 'Select a Daily Habit...',
    builderQuestionText: 'Question text',
    builderQuestionTextPlaceholder: 'Write the question here',
    builderIconLabel: 'Icon',
    builderOptional: '(optional)',
    builderChangeIcon: 'Change',
    builderSelectIconBtn: 'Select icon',
    builderOptionsLabel: 'Options (max. 4 + "Not Observable")',
    builderNoObservable: 'Not Observable',
    builderRemoveNoObs: 'Remove Not Observable',
    builderAddNoObs: 'Add "Not Observable"',
    builderAddOption: 'Add Option',
    builderMaxOptions: 'Maximum of 4 options reached',
    builderNPSInfo: 'NPS: scale from 0 to 10. Open question, not assigned to participants.',
    builderOpenInfo: 'Open space for the evaluator to write their response.',
    builderCampaignWeight: 'Campaign weight',
    builderAdminGlobalOnly: 'Global Admin only',
    builderCampaignWeightSub: 'Higher weight = higher priority when multiple surveys are active. Only the Global Admin can modify it.',
    builderWeightBase: 'Base weight (1–10)',
    builderWeightVeryLow: 'Very Low',
    builderWeightLow: 'Low',
    builderWeightMedium: 'Medium',
    builderWeightHigh: 'High',
    builderWeightVeryHigh: 'Very High',
    builderBoostUrgent: 'Urgent boost',
    builderBoostUrgentSub: 'Temporarily elevates this survey above all others',
    builderBoostDays: 'days',
    builderBoostActiveDays: 'day',
    builderBoostActiveMsg: 'Boost active — this survey will have maximum priority for',
    builderNoBoostMsg: 'No active boost — priority based on base weight',
    builderParticipantsTitle: 'Participants to evaluate',
    builderParticipantsSub: 'Define how many people are evaluated per survey. Minimum for anonymity and maximum to avoid overload.',
    builderMinParticipantsLabel: 'Minimum participants',
    builderMinParticipantsHint: 'Min. to ensure anonymity',
    builderMaxParticipantsLabel: 'Maximum participants',
    builderMaxParticipantsHint: 'Max. people to evaluate per survey',
    builderPrivacyTitle: 'Privacy and anonymity',
    builderPrivacySub: 'Define whether feedback will be linked to the respondent\'s identity.',
    builderEnableAnonymity: 'Enable anonymity',
    builderAnonymityDesc: 'Feedback will not include the username — only the response and time',
    builderTranslationsTitle: 'Translations',
    builderTranslationsEuropeSub: 'Europe audience — all 6 languages required. Use the toggle to enable or disable a language.',
    builderTranslationsSub: 'English translation is required as a minimum. Use the toggle to enable additional languages.',
    builderAutoTranslateNote: 'Translations are generated automatically with Azure Translator. Review and adjust each field as needed.',
    builderLangNotApplicable: 'Not applicable',
    builderLangComplete: 'Done',
    builderLangPending: 'Pending',
    builderLangRequired: 'Required',
    builderAutoTranslateBtn: 'Auto-translate',
    builderLangApplies: 'Applies',
    builderLangDoesNotApply: 'Does not apply',
    builderTrlName: 'Name:',
    builderTrlDesc: 'Description:',
    builderTrlEmpty: 'empty',
    builderLangDisabled: 'This language is disabled for this survey.',
    builderReviewTitle: 'Review and publish',
    builderReviewTemplateTitle: 'Review template',
    builderEuropaPublishNote: 'Europe mode: independent campaign due to GDPR. Remember to obtain authorization from the Europe OU.',
    builderPublishIdLabel: 'Identifier',
    builderPublishInternal: '(internal)',
    builderPublishTypeLabel: 'Type',
    builderPublishAudienceLabel: 'Audience',
    builderPublishQuestionsLabel: 'Questions',
    builderPublishActiveDaysLabel: 'Active days',
    builderPublishExpirationLabel: 'Expiration',
    builderPublishAnonymityLabel: 'Anonymity',
    builderPublishAnonymousVal: 'Anonymous',
    builderPublishNominalVal: 'Nominal',
    builderCompleteBeforePublish: 'Complete before publishing:',
    builderCompleteBeforeSave: 'Complete before saving:',
    builderReadyToPublish: 'All set. Click Publish Survey to activate it.',
    builderReadyToSaveTemplate: 'All set. Click Save Template to save it.',
    builderIconCatalogTitle: 'Icon catalog',
    builderSystemIcons: 'System icons',
    builderNoIcon: 'No icon',
    builderMyCatalog: 'My catalog',
    builderDeleteFromCatalog: 'Delete from catalog',
    builderCatalogEmpty: 'Your catalog is empty — upload an icon and save it here',
    builderUploadIcon: 'Upload new icon',
    builderIconNamePlaceholder: 'Icon name (e.g. Innovation)',
    builderSelectFile: 'Select file',
    builderInvalidFormat: 'Invalid format. Use SVG or PNG with a transparent background.',
    builderFileTooLarge: 'File too large. Maximum 200 KB.',
    builderCustomIcon: 'Custom icon',
    builderSaveForReuse: 'Save to catalog for reuse',
    builderUseIcon: 'Use icon',
    builderIconHelp: 'SVG or PNG, transparent background, 512×512 px recommended, max. 200 KB',
    builderPreviewCompleteStep1: 'Complete Step 1 data to see the preview',
    builderPreviewClickToEdit: 'Click any text to edit',
    builderPreviewNoQuestions: 'Questions will appear here in Step 3',
    builderPreviewGeneral: 'General',
    builderPreviewPersonalized: 'Personalized',
    builderPreviewPulsoEspecifica: 'Specific Pulse',
    builderPreviewChangeIcon: 'Change icon',
    builderPreviewIndividual: 'Individual',
    builderPreviewCollective: 'Collective',
    builderPreviewModeIndividual: 'Individual',
    builderPreviewModeMatrix: 'General Matrix',
    builderPreviewMissingTranslation: '(no translation)',
    builderPreviewWriteAnswer: 'Write your answer here...',
    builderPreviewNoObs: 'Not Observable',
    builderPreviewNA: 'N/A',
    // Step nav labels
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Audience',
    builderNavPreguntas: 'Questions',
    builderNavConfig: 'Settings',
    builderNavPublicar: 'Publish',
    builderNavGuardar: 'Save',
    // Step 1 title
    builderInfoTitle: 'Basic information',
    // Audience step
    builderSelectAll: 'Select all',
    // Language names
    langEn: 'English',
    langDe: 'German',
    langPt: 'Portuguese',
    langFr: 'French',
    langNl: 'Dutch',
    langRo: 'Romanian',
    // Translation placeholders
    builderTrlPlaceholderIn: 'in',
    builderTrlPlaceholderOpt: 'Option',
    builderTrlNoText: 'No text yet',
    // New keys added during refactor
    builderLinkedTo: 'Linked to',
    builderSelectedIcon: 'Selected',
    builderHidePreview: 'Hide preview',
    builderShowPreview: 'Show preview',
    builderPreviewMorePersons: 'more people',
    builderPreviewOption1: 'Option 1',
    builderPreviewOption2: 'Option 2',
    builderPreviewViewIn: 'View in:',
    builderFromOU: 'from',
    builderWillReceiveSurvey: 'will receive this survey',
    builderPersonsCount: 'people',
    builderPersonsPlural: 'people',
    builderPersonSingular: 'person',
    builderInternalIdPlaceholder: 'E.g. Fundamentals Q1 2026',
    builderMeetingIdPlaceholder: 'E.g. 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Option',
    builderRemovePerson: 'Remove',
    builderSaveTemplateMock: 'Saved as template ✓',
    builderPublishGlobalLabel: 'Global (excl. Europe)',
    builderTypeRating: 'Rating (1-4)',
    builderTypeMultiple: 'Multiple Choice',
    builderTypeOpen: 'Open Question',
    builderTypeBehaviors: 'Behaviors',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'System',
    // Monitor tab
    monitorTab: 'Monitoring',
    // Jobs tab
    jobsTab: 'Jobs',
  },
  jobs: {
    title: 'AD Sync Jobs',
    subtitle: 'Status, history and manual execution of the jobs that sync OUs and users from Azure AD.',
    ouCatalogSync: 'OU Sync',
    userCatalogSync: 'User Sync',
    statusNeverRun: 'Never run',
    statusRunning: 'Running…',
    statusSuccess: 'Success',
    statusSkipped: 'Skipped',
    statusFailed: 'Error',
    lastRun: 'Last run',
    duration: 'Duration',
    triggerScheduled: 'Scheduled',
    triggerManual: 'Manual',
    created: 'Created',
    updated: 'Updated',
    unchanged: 'Unchanged',
    skipReason: 'Reason',
    errorMessage: 'Error',
    nextScheduled: 'Next scheduled run',
    nextScheduledUnknown: 'Computed after the first run',
    runNow: 'Run now',
    runningDisabled: 'Already running',
    viewHistory: 'View history',
    hideHistory: 'Hide history',
    historyEmpty: 'No runs recorded yet.',
    historyLoading: 'Loading history…',
    historyError: 'Could not load history.',
    colDate: 'Date',
    colTrigger: 'Trigger',
    colStatus: 'Status',
    colDuration: 'Duration',
    colDetail: 'Detail',
    triggerError: 'Could not run the job.',
    triggerConflict: 'The job is already running — wait for it to finish.',
  },
  monitor: {
    title: 'Pipeline Monitor',
    subtitle: 'Eligibility audit per meeting: rules evaluated, excluded participants and sampling applied.',
    refresh: 'Refresh',
    loading: 'Loading events…',
    lastFetch: 'Updated',
    timeout: 'Timeout (10s) — MeetingService did not respond.',
    unknownError: 'Unknown error',
    empty: 'No pipeline events. Process or simulate a meeting to see records.',
    eligible: 'Eligible',
    ineligible: 'Ineligible',
    excluded: 'Excluded',
    sampled: 'Sampled',
    samplingApplied: 'Sampling applied',
    noParticipants: 'No participant detail.',
    statTotal: 'Processed meetings',
    statEligible: 'Eligible meetings',
    statAvgSampled: 'Avg. sampled',
    statAvgSampledSub: 'per eligible meeting',
    statSampling: 'Sampling applied',
    statSamplingSub: 'meetings with maxPax active',
    colMeetingId: 'Meeting ID',
    colDate: 'Date',
    colDuration: 'Duration',
    colEvaluated: 'Evaluated',
    colEligible: 'Eligible',
    colSampled: 'Sampled',
    colMaxPax: 'Sampling',
    colResult: 'Result',
    colUserId: 'User',
    colOu: 'OU',
    colTimezone: 'Timezone',
    colToday: 'Today',
    colWeek: 'Week',
    colInterval: 'Interval',
    colStatus: 'Status',
    colReason: 'Reason',
    colSample: 'Survey',
    instancesTitle: 'Assigned surveys',
    instancesBtnTitle: 'View surveys for this participant',
    instancesLoading: 'Loading surveys…',
    instancesEmpty: 'No survey instances found for this participant in this meeting.',
    instancesSurvey: 'Survey',
    instancesStatus: 'Status',
    instancesExpires: 'Expires',
    instancesDownload: 'Download JSON',
    instancesClose: 'Close',
    sortAsc: 'Sort ascending',
    sortDesc: 'Sort descending',
    recalculate: 'Recalculate responses',
    recalculateTitle: 'Recalculate response count on all surveys',
    recalculateSuccess: 'Recalculation complete: {{count}} survey(s) updated.',
    recalculateError: 'Error recalculating responses.',
    cacheTitle: 'OU catalog cache',
    cacheLoading: 'Checking cache…',
    cacheError: 'Could not fetch OU cache status.',
    cachePopulated: 'Populated',
    cacheNotPopulated: 'Not populated',
    cacheOuCount: 'Cached OUs',
    cacheLastSynced: 'Last synced',
    cacheNeverSynced: 'Never synced',
  },
  system: {
    title: 'System Diagnostics',
    subtitle: 'Real-time status of all backend microservices and workers.',
    refreshAll: 'Refresh all',
    refresh: 'Refresh',
    lastChecked: 'Last checked',
    checking: 'Checking…',
    never: 'Never',
    statusHealthy: 'Healthy',
    statusDegraded: 'Degraded',
    statusError: 'Connection Error',
    showDetails: 'Show checks',
    hideDetails: 'Hide checks',
    legendTitle: 'Status glossary',
    legendHealthyDesc: 'All internal service checks responded correctly.',
    legendDegradedDesc: 'The service responds but MongoDB, Redis, or Service Bus reported an error.',
    legendErrorDesc: 'The service could not be reached from the frontend (timeout, CORS, or service down).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Subscriptions',
    activeMessages: 'Active messages',
    deadLetterMessages: 'Dead Letter',
    environment: 'Environment',
    version: 'Version',
    workers: 'Workers',
    workersDesc: 'Status inferred from Service Bus subscription stats.',
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: 'No subscription statistics available.',
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Error',
  },
  analytics: {
    title: 'Executive Dashboard',
    subtitle: 'Sigma Pulse Analytics',
    bias: 'Biases',
    omissions: 'Omissions',
    personal: 'Personal',
    score: 'Score',
    responses: 'Responses',
    participants: 'Participants',
    period: 'Period',
    ou: 'Organizational Unit',
    noData: 'Insufficient data',
    completionRate: 'Completion rate',
    avgByCategory: 'Average by category',
    organization: 'Organization',
    fundamentalsRadar: 'Fundamentals radar',
    heatmapPersonFund: 'Heat map — Score by person and fundamental',
    moduleInDev: 'Module in development',
    executiveSubtitle: 'executive view',
    exec: {
      ouTech: 'Technology',
      ouOps: 'Operations',
      ouSales: 'Sales',
    },
    tabs: {
      summary: 'Summary',
      fundamentals: 'Fundamentals',
      heatmap: 'Heat Map',
      orgNetwork: 'Org Network',
      generational: 'Generational',
    },
    filterBar: {
      allOrg: 'All organization',
      allBU: 'All BUs',
      allDept: 'All Depts',
      allFund: 'All fundamentals',
      clearFilters: 'Clear filters',
      dateFrom: 'From',
      dateTo: 'To',
    },
    kpi: {
      evaluations: 'Evaluations',
      avgScore: 'Avg Score',
      responseRate: 'Response Rate',
      avgPerDay: 'Avg / Day',
      evaluators: 'Evaluators',
      scale: 'scale 1–4',
      noObservables: 'not observable',
      perDay: 'surveys per day',
      activeParticipants: 'active participants',
      ofTotal: 'total',
    },
    summary: {
      topBehaviors: 'Top Daily Habits',
      topDailyHabitsSubtitle: 'Habits with highest cultural impact',
      oppSubtitle: 'Habits with most room for improvement',
      opportunities: 'Opportunity Areas',
      omissionsByUnit: 'Omissions by Unit',
      omissionsSubtitle: 'Omission rate by OU and BU — sorted highest to lowest · Click on an OU to see its BUs',
      downloadExcel: 'Download Excel',
      omitType: 'Type',
      omitPeople: 'People',
      omitRate: 'Omission Rate',
      noOmissions: 'No significant omissions',
      percentileDistribution: 'Percentile Distribution',
      percentileSubtitle: 'Percentage of the population in each score range',
      personsEvaluated: 'people evaluated',
      excellent: 'Excellent',
      good: 'Good',
      developing: 'Developing',
      attention: 'Attention',
      fundPositioning: 'Fundamentals Positioning',
      fundPositioningDesc: 'Ranking, highest/lowest score and no-observable rate by fundamental',
      highestScore: 'Highest score',
      lowestScore: 'Lowest score',
      mostNoObs: 'Most Not Observable',
      scoreByOU: 'Score by Organizational Unit',
      scoreByOUSubtitle: 'Click on an OU to see the breakdown by BU and Department',
      person: 'person',
      persons: 'people',
    },
    fundamentals: {
      title: 'Score by Fundamental',
      subtitle: 'Expand each fundamental to see its daily habits and breakdown by OU',
      evalLabel: 'eval',
      confPreliminary: 'Preliminary data',
      confBasedOn: 'Based on {{n}} eval',
    },
    heatmap: {
      title: 'Cultural Heat Map',
      subtitle: 'Tap any row to explore its sub-units',
      unit: 'Unit',
      unitOU: 'Organizational Unit',
      unitBU: 'Business Unit',
      unitDept: 'Department',
      unitPerson: 'Lead',
      allOrg: 'All organization',
      hint: 'Tap any row to explore the next level →',
      person: 'person',
      persons: 'people',
      legendCritical: 'Critical',
      legendLow: 'Low',
      legendMedium: 'Medium',
      legendGood: 'Good',
      legendExcellent: 'Excellent',
      noOu: 'No OU',
    },
    ona: {
      title: 'Organizational Network (ONA)',
      subtitle: 'Interactive tree of organizational units (OU)',
      treeHint: 'Expand each node to navigate the organization\'s OU levels.',
      omissions: 'Omissions',
      totalPeople: 'People',
      avgScore: 'Avg score',
      totalEvals: 'Total evaluations',
      collaboratorsKpi: 'Collaborators',
      highestOmission: 'Highest omission',
      omissionsRanking: 'Omissions ranking',
      maturityCulture: 'Cultural maturity',
      maturityLegend: 'Maturity legend',
      maturityInitial: 'Initial',
      maturityGrowing: 'Growing',
      maturityConsolidated: 'Consolidated',
      maturityRoleModel: 'Role Model',
      evalsLabel: 'evaluations',
      noEvals: 'No evaluations',
      collaboratorsLabel: 'collaborators',
      omissionLabel: 'omission',
      evalsShort: 'evals',
    },
    gen: {
      panorama: 'Overview',
      ranking: 'Ranking',
      brechas: 'Gaps',
      avgAge: 'Avg age',
      title: 'Generational Analysis',
      subtitle: 'Cultural distribution and maturity by cohort · {{n}} people mapped',
      noRepresentation: 'No representation',
      scoreLabel: 'Score',
      omissionLabel: 'Omission',
      personas: 'people',
      age: 'Age',
      all: 'All',
      noData: 'No data for this filter',
      fundamental: 'Fundamental',
      gapCol: 'Δ Gap',
      brechaNote: 'Largest gap: {{fund}} · Δ {{delta}} pts across generations',
      brechaSource: 'Difference vs. the fundamental\'s overall company average',
      responseCount: '{{n}} responses',
    },
  },
  userConfig: {
    fabTitle: 'Configure user profile',
    title: 'User profile (demo)',
    subtitle: 'Test mode — simulates data that will come from Teams SSO on backend integration',
    nombre: 'Name',
    correo: 'Email',
    ou: 'OU (Organizational Unit)',
    do_: 'DO (Division)',
    bu: 'BU (Business Unit)',
    departamento: 'Department',
    puesto: 'Job title',
    numeronomina: 'Employee number',
    role: 'Role',
    roleDetected: 'Detected role',
    roleNotFound: 'Email not found in users — Employee role will be used',
    save: 'Save profile',
    namePlaceholder: 'E.g.: Ana García',
    emailPlaceholder: 'E.g.: agarcia@sigma.com',
    ouPlaceholder: 'E.g.: Technology',
    doPlaceholder: 'E.g.: Technology Division',
    buPlaceholder: 'E.g.: Mexico',
    deptPlaceholder: 'E.g.: Software Development',
    puestoPlaceholder: 'E.g.: Senior Software Engineer',
    nominaPlaceholder: 'E.g.: 123456',
    fechaNacimiento: 'Date of birth',
    tenant: 'Tenant',
  },
  errors: {
    generic: 'An unexpected error occurred',
    unauthorized: "You don't have permission for this action",
    notFound: 'Resource not found',
    network: 'Connection error. Check your network.',
  },
};

export default en;

